import React, { useState, useContext, useRef, useEffect } from 'react';

import {
	Typography,
	Stack,
	Paper,
	Grid,
	TableContainer,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
	IconButton,
	Container
} from '@mui/material';
import moment from 'moment';
import ReactToPrint from 'react-to-print';
import PrintRoundedIcon from '@mui/icons-material/PrintRounded';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faChevronCircleLeft } from '@fortawesome/free-solid-svg-icons';
import { getLiquidacionByEmployeeAsync } from '../../../../api/Employees';
import { DataContext } from '../../../../context/DataContext';
import { getToken } from '../../../../api/Account';
import { simpleMessage } from '../../../../helpers/Helpers';
import { PrintReport } from '../../../../components/PrintReport';
import { conv2Letras } from '../../../../helpers/n2Letras';

const PrintLiquidacion = ({ empleadoId }) => {
	const [dataLiquidacion, setDataLiquidacion] = useState(null);
	const { title, slogan, icon, setIsLoading, setIsUnautorized } = useContext(DataContext);

	const compRef = useRef();

	const token = getToken();
	useEffect(() => {
		getDataLiquidacion();
	}, []);

	const getDataLiquidacion = async () => {
		setIsLoading(true);
		const result = await getLiquidacionByEmployeeAsync(token, empleadoId);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}
		setDataLiquidacion(result.data.result);
		setIsLoading(false);
	};

	const getTotal = (detalle) => {
		let result = 0;
		detalle.map((item) => {
			result += item.valor;
		});

		return result;
	};

	const pageStyle = `
	@media print {
	  html, body {
		height: initial !important;
		overflow: initial !important;
		-webkit-print-color-adjust: exact;
	  }
	}
	@media all {
	  .pagebreak {
		display: none;
	  }
	}
	@media print {
	  .pagebreak {
		page-break-before: always;
	  }
	}  
	@page { size: Letter portrait; margin: 10mm; }
  `;

	return dataLiquidacion === null ? (
		<></>
	) : (
		<div>
			<Paper
				style={{
					padding: 20,
					textAlign: 'center'
				}}
			>
				<Stack direction={'row'} display="flex" justifyContent="space-between">
					<Stack direction={'row'} alignItems="center" spacing={1}>
						<Typography>FECHA FIN CONTRATO: </Typography>
						<Typography fontWeight={'bold'}>
							{moment(dataLiquidacion.employee.fechaFinContrato).format('L')}
						</Typography>
					</Stack>

					<ReactToPrint
						trigger={() => {
							return (
								<IconButton
									variant="outlined"
									style={{ position: 'absolute', right: 50, top: 75 }}
								>
									<PrintRoundedIcon
										style={{ fontSize: 35, color: '#2979ff', width: 35 }}
									/>
								</IconButton>
							);
						}}
						content={() => compRef.current}
						pageStyle={pageStyle}
					/>
				</Stack>

				<hr />
				<Grid container spacing={1}>
					<Grid item xs={6}>
						<Typography color="#2979ff" textAlign={'left'}>
							EMPLEADO:
						</Typography>
					</Grid>
					<Grid item xs={6}>
						<Typography textAlign="left">
							{dataLiquidacion.employee.fullName}
						</Typography>
					</Grid>
					<Grid item xs={6}>
						<Typography color="#2979ff" textAlign={'left'}>
							CEDULA:
						</Typography>
					</Grid>
					<Grid item xs={6}>
						<Typography textAlign="left">
							{dataLiquidacion.employee.identification}
						</Typography>
					</Grid>
					<Grid item xs={6}>
						<Typography color="#2979ff" textAlign={'left'}>
							FECHA DE INGRESO:
						</Typography>
					</Grid>
					<Grid item xs={6}>
						<Typography textAlign="left">
							{moment(dataLiquidacion.employee.fechaInicioContrato).format('L')}
						</Typography>
					</Grid>
					<Grid item xs={6}>
						<Typography color="#2979ff" textAlign={'left'}>
							ANTIGUEDAD:
						</Typography>
					</Grid>
					<Grid item xs={6}>
						<Typography textAlign="left">{dataLiquidacion.antiguedad}</Typography>
					</Grid>
					<Grid item xs={6}>
						<Typography color="#2979ff" textAlign={'left'}>
							VACACIONES DISPONIBLES:
						</Typography>
					</Grid>
					<Grid item xs={6}>
						<Typography textAlign="left">
							{dataLiquidacion.vacaionesDisponibles}
						</Typography>
					</Grid>
					<Grid item xs={6}>
						<Typography color="#2979ff" textAlign={'left'}>
							SALARIO BASICO:
						</Typography>
					</Grid>
					<Grid item xs={6}>
						<Typography textAlign="left">
							{new Intl.NumberFormat('es-NI', {
								style: 'currency',
								currency: 'NIO'
							}).format(dataLiquidacion.salarioBasico)}
						</Typography>
					</Grid>
				</Grid>
			</Paper>

			<Paper
				style={{
					marginTop: 10,
					padding: 20,
					textAlign: 'center'
				}}
			>
				<TableContainer>
					<Table aria-label="simple table" size="small">
						<TableHead>
							<TableRow>
								<TableCell align="center" className="text-primary fw-bold">
									#
								</TableCell>
								<TableCell align="left" className="text-primary fw-bold">
									Detalle
								</TableCell>
								<TableCell align="center" className="text-primary fw-bold">
									Desde
								</TableCell>
								<TableCell align="center" className="text-primary fw-bold">
									Hasta
								</TableCell>
								<TableCell align="center" className="text-primary fw-bold">
									Dias
								</TableCell>
								<TableCell align="center" className="text-primary fw-bold">
									Valor
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{dataLiquidacion.liquidacionDetails.map((row) => {
								const { detalle, desde, hasta, dias, valor } = row;
								return (
									<TableRow
										key={dataLiquidacion.liquidacionDetails.indexOf(row) + 1}
									>
										<TableCell align="center" component="th" scope="row">
											{dataLiquidacion.liquidacionDetails.indexOf(row) + 1}
										</TableCell>
										<TableCell align="left">{detalle}</TableCell>
										<TableCell align="center">
											{moment(desde).format('L')}
										</TableCell>
										<TableCell align="center">
											{moment(hasta).format('L')}
										</TableCell>
										<TableCell align="center">{dias.toFixed(2)}</TableCell>
										<TableCell align="center">
											{new Intl.NumberFormat('es-NI', {
												style: 'currency',
												currency: 'NIO'
											}).format(valor)}
										</TableCell>
									</TableRow>
								);
							})}
							<TableRow key={0}>
								<TableCell align="left" component="th" scope="row" colSpan={4} />
								<TableCell
									align="left"
									style={{
										fontSize: 15,
										color: '#ffc400',
										fontWeight: 'bold'
									}}
								>
									Total
								</TableCell>
								<TableCell
									align="center"
									style={{
										fontSize: 15,
										color: '#ffc400',
										fontWeight: 'bold'
									}}
								>
									{new Intl.NumberFormat('es-NI', {
										style: 'currency',
										currency: 'NIO'
									}).format(getTotal(dataLiquidacion.liquidacionDetails))}
								</TableCell>
							</TableRow>
						</TableBody>
					</Table>
				</TableContainer>
			</Paper>

			<div
				style={{
					display: 'none'
				}}
			>
				<PrintReport ref={compRef} titulo={'Liquidacion de Prestaciones Sociales'}>
					<Container maxWidth={false} sx={{ textAlign: 'center' }}>
						<hr />
						<Stack
							direction={'row'}
							alignItems="center"
							spacing={1}
							justifyContent="space-between"
						>
							<Typography textAlign="right" fontSize={11}>
								{`Comprobante de Liquidacion N° ${dataLiquidacion.id}`}
							</Typography>
							<Stack direction={'row'} alignItems="center" spacing={1}>
								<Typography fontSize={11}>FECHA FIN CONTRATO: </Typography>
								<Typography fontWeight={'bold'} fontSize={11}>
									{moment(dataLiquidacion.employee.fechaFinContrato).format('L')}
								</Typography>
							</Stack>
						</Stack>

						<hr />
						<Grid container>
							<Grid item xs={6}>
								<Typography color="#2979ff" textAlign={'left'} fontSize={10}>
									EMPLEADO:
								</Typography>
							</Grid>
							<Grid item xs={6}>
								<Typography textAlign="left" fontSize={10}>
									{dataLiquidacion.employee.fullName}
								</Typography>
							</Grid>
							<Grid item xs={6}>
								<Typography color="#2979ff" textAlign={'left'} fontSize={10}>
									CEDULA:
								</Typography>
							</Grid>
							<Grid item xs={6}>
								<Typography textAlign="left" fontSize={10}>
									{dataLiquidacion.employee.identification}
								</Typography>
							</Grid>
							<Grid item xs={6}>
								<Typography color="#2979ff" textAlign={'left'} fontSize={10}>
									FECHA DE INGRESO:
								</Typography>
							</Grid>
							<Grid item xs={6}>
								<Typography textAlign="left" fontSize={10}>
									{moment(dataLiquidacion.employee.fechaInicioContrato).format(
										'L'
									)}
								</Typography>
							</Grid>
							<Grid item xs={6}>
								<Typography color="#2979ff" textAlign={'left'} fontSize={10}>
									ANTIGUEDAD:
								</Typography>
							</Grid>
							<Grid item xs={6}>
								<Typography textAlign="left" fontSize={10}>
									{dataLiquidacion.antiguedad}
								</Typography>
							</Grid>
							<Grid item xs={6}>
								<Typography color="#2979ff" textAlign={'left'} fontSize={10}>
									VACACIONES DISPONIBLES:
								</Typography>
							</Grid>
							<Grid item xs={6}>
								<Typography textAlign="left" fontSize={10}>
									{dataLiquidacion.vacaionesDisponibles}
								</Typography>
							</Grid>
							<Grid item xs={6}>
								<Typography color="#2979ff" textAlign={'left'} fontSize={10}>
									SALARIO BASICO:
								</Typography>
							</Grid>
							<Grid item xs={6}>
								<Typography textAlign="left" fontSize={10}>
									{new Intl.NumberFormat('es-NI', {
										style: 'currency',
										currency: 'NIO'
									}).format(dataLiquidacion.salarioBasico)}
								</Typography>
							</Grid>
						</Grid>

						<Stack
							style={{
								marginTop: 10,
								padding: 20,
								textAlign: 'center'
							}}
						>
							<TableContainer>
								<Table aria-label="simple table" size="small">
									<TableHead>
										<TableRow>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												#
											</TableCell>
											<TableCell
												align="left"
												className="text-primary fw-bold"
											>
												Detalle
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Desde
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Hasta
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Dias
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Valor
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{dataLiquidacion.liquidacionDetails.map((row) => {
											const { detalle, desde, hasta, dias, valor } = row;
											return (
												<TableRow
													key={
														dataLiquidacion.liquidacionDetails.indexOf(
															row
														) + 1
													}
												>
													<TableCell
														align="center"
														component="th"
														scope="row"
														className="text-dark"
														style={{ fontSize: '10px' }}
													>
														{dataLiquidacion.liquidacionDetails.indexOf(
															row
														) + 1}
													</TableCell>
													<TableCell
														align="left"
														className="text-dark"
														style={{ fontSize: '10px' }}
													>
														{detalle}
													</TableCell>
													<TableCell
														align="center"
														className="text-dark"
														style={{ fontSize: '10px' }}
													>
														{moment(desde).format('L')}
													</TableCell>
													<TableCell
														align="center"
														className="text-dark"
														style={{ fontSize: '10px' }}
													>
														{moment(hasta).format('L')}
													</TableCell>
													<TableCell
														align="center"
														className="text-dark"
														style={{ fontSize: '10px' }}
													>
														{dias.toFixed(2)}
													</TableCell>
													<TableCell
														align="center"
														className="text-dark"
														style={{ fontSize: '10px' }}
													>
														{new Intl.NumberFormat('es-NI', {
															style: 'currency',
															currency: 'NIO'
														}).format(valor)}
													</TableCell>
												</TableRow>
											);
										})}
										<TableRow key={0}>
											<TableCell
												align="left"
												component="th"
												scope="row"
												colSpan={4}
											/>
											<TableCell
												align="left"
												style={{
													fontSize: 15,
													fontWeight: 'bold'
												}}
												className="text-dark"
											>
												Total
											</TableCell>
											<TableCell
												align="center"
												style={{
													fontSize: 15,

													fontWeight: 'bold'
												}}
												className="text-dark"
											>
												{new Intl.NumberFormat('es-NI', {
													style: 'currency',
													currency: 'NIO'
												}).format(
													getTotal(dataLiquidacion.liquidacionDetails)
												)}
											</TableCell>
										</TableRow>
									</TableBody>
								</Table>
							</TableContainer>
						</Stack>

						<p style={{ textAlign: 'justify', fontSize: 11 }}>
							RECIBO A MI ENTERA SATISFACCION LA CANTIDAD DE:
							<span style={{ fontWeight: 'bold', marginLeft: 5, marginRight: 5 }}>
								{`${new Intl.NumberFormat('es-NI', {
									style: 'currency',
									currency: 'NIO'
								}).format(
									getTotal(dataLiquidacion.liquidacionDetails)
								)} (${conv2Letras(getTotal(dataLiquidacion.liquidacionDetails))}).`}
							</span>
							POR CONCEPTO DE LiQUIDACION Y PAGO fINAL DE TODAS Y CADA UNA DE MIS
							PRESTACIONES LABORALES, ORDINARIAS Y EXTRAORDINARIAS, LEGALES Y
							CONTRACTUALES A LAS QUE TENGO DERECHO
						</p>

						<Typography textAlign="center" marginTop={10}>
							_________________________________________
						</Typography>
						<Typography textAlign="center">
							{dataLiquidacion.employee.fullName}
						</Typography>
					</Container>
				</PrintReport>
			</div>
		</div>
	);
};

export default PrintLiquidacion;
